// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_breadcrumb__QozIj","slash":"breadcrumb_slash__Prk9x"};